import { defineComponent as _defineComponent } from 'vue'
import FilterForm from "@/features/project-stt-settings/FilterForm.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSttSettings',
  props: {
    projectId: null
  },
  setup(__props: any) {

const props = __props as {
  projectId: number
}



return { __sfc: true,props, FilterForm }
}

})